/**
 * Version stamp for the Risk Mgmt Panel. Bumped per PCB versioning rule on
 * every deployable build. Surfaced in the topbar + footer + console so Bill
 * can identify what's running.
 *
 * The build stamps VITE_APP_VERSION from package.json `version` (vite.config.ts,
 * Bill 2026-10-21) — bump package.json only; the fallback below is for tests.
 */

export const APP_VERSION =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? '0.24.1';

export const APP_BUILD_TIME = new Date().toISOString();

export const APP_NAME = 'PCB Risk Mgmt Panel';
